(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-footer-menu-title]').forEach(title => {
    title.addEventListener('click', () => {
      const content = title.parentElement.querySelector('[data-footer-menu-content]');
      if (content) {
        content.classList.toggle('footer-menu-opened');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
